import { render, staticRenderFns } from "./NewCollectionModal.vue?vue&type=template&id=26c74f27&"
import script from "./NewCollectionModal.vue?vue&type=script&lang=js&"
export * from "./NewCollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./NewCollectionModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports